import api from '../lib/api';
import type { ApiResponse } from '@maios/shared';

export interface AuditLogItem {
  id: string;
  actorId: string | null;
  actorName: string;
  actorEmail: string | null;
  action: string;
  targetType: string;
  targetId: string | null;
  targetName: string | null;
  detail: Record<string, unknown> | null;
  ipAddress: string | null;
  createdAt: string;
}

export interface AuditLogListResponse {
  items: AuditLogItem[];
  pagination: { page: number; limit: number; total: number; totalPages: number };
}

export interface AuditLogListParams {
  page?: number;
  limit?: number;
  action?: string;
  actorId?: string;
  targetType?: string;
  targetId?: string;
  from?: string;
  to?: string;
  search?: string;
}

export interface AuditLogStats {
  period: { from: string; to: string };
  totalCount: number;
  byAction: Array<{ action: string; count: number }>;
  dailyTrend: { labels: string[]; data: number[] };
  topActors: Array<{ actorId: string; actorName: string; count: number }>;
}

export async function getAuditLogs(params: AuditLogListParams): Promise<AuditLogListResponse> {
  const query = new URLSearchParams();
  if (params.page) query.set('page', String(params.page));
  if (params.limit) query.set('limit', String(params.limit));
  if (params.action) query.set('action', params.action);
  if (params.actorId) query.set('actorId', params.actorId);
  if (params.targetType) query.set('targetType', params.targetType);
  if (params.targetId) query.set('targetId', params.targetId);
  if (params.from) query.set('from', params.from);
  if (params.to) query.set('to', params.to);
  if (params.search) query.set('search', params.search);

  const res = await api.get<ApiResponse<AuditLogListResponse>>(`/admin/audit-logs?${query}`);
  return res.data.data!;
}

export async function getAuditLogStats(days: number = 30): Promise<AuditLogStats> {
  const res = await api.get<ApiResponse<AuditLogStats>>(`/admin/audit-logs/stats?days=${days}`);
  return res.data.data!;
}
